import services from '@/fetch'
import { logoutUrl } from '@/config'
import {removeAccount, /* logout, */ getAccount, setAccount, setOrigin, getOrigin, removeOrigin} from '@/utils/auth'
import { Loading } from 'element-ui'

const initState = {
  // token: getAccount(),
  name: '',
  role: '',
  uid: '',
  entityId: '',
  account: '',
  loginErrorCount: 0,
  menus: null,
  controls: null,
  smsVerify: 0
}

const getCurrentMenuInfo = function (menus, path) {
  let flag = false
  for (var i = 0; i < menus.length; i++) {
    if (menus[i].url === path && menus[i].url && path) {
      flag = true
    } else if (menus[i].children && menus[i].children.length > 0) {
      flag = getCurrentMenuInfo(menus[i].children, path)
    }
    if (flag) {
      break
    }
  }
  return flag
}
const getLogoutURL = function (origin) {
  // 判断是否是华侨城环境，然后跳转到华侨城地址
  if (logoutUrl) {
    location.href = logoutUrl
  } else {
    setTimeout(() => {
      location.href = origin || '/'
    }, 1000)
  }
}

const user = {
  state: {
    ...initState
  },
  mutations: {
    SET_SMS_VERIFY: (state, flag) => {
      state.smsVerify = flag
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_ROLE: (state, role) => {
      state.role = role
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_CONTROLS: (state, controls) => {
      state.controls = controls
    },
    SET_UID: (state, uid) => {
      state.uid = uid
    },
    SET_ENTITY_ID: (state, entityId) => {
      state.entityId = entityId
    },
    SET_ACCOUNT: (state, account) => {
      state.account = account
    },
    SET_LOGIN_ERROR_COUNT: (state, loginErrorCount) => {
      state.loginErrorCount = loginErrorCount
    }
  },
  actions: {
    // 生存用户信息
    async GenerateUserInfo ({commit}) {
      const info = await services.currentUser({method: 'get'})
      if (!info) return
      // const info = JSON.parse(getAccount())
      commit('SET_NAME', info.user.username)
    },
    // 获取菜单信息
    GetMenuTree ({commit}, path) {
      return new Promise(async (resolve, reject) => {
        try {
          let loadingInstance = Loading.service({
            lock: true,
            background: 'rgba(255, 255, 255, 0.3)'
          })
          const res = await services.getUserMenuTree({method: 'get'})
          const resPrivilege = await services.userPrivilege({method: 'get'})
          loadingInstance.close()
          const {uid, entityId, account} = JSON.parse(getAccount())
          commit('SET_MENUS', res.appMenu) // 记录所有菜单
          commit('SET_CONTROLS', resPrivilege.privilege) // 记录角色权限
          // commit('SET_NAME', nickname)
          commit('SET_UID', uid)
          commit('SET_ENTITY_ID', entityId)
          commit('SET_ACCOUNT', account)
          // commit('SET_ROLE', 'SUPADMIN')
          resolve()
        } catch (e) {
          reject(e)
        }
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(async (resolve, reject) => {
        // removeLoginId()
        const origin = getOrigin()
        removeAccount()
        removeOrigin()
        // const suburl = loginId ? `/#/login/${loginId}` : ''
        try {
          await services.loginOut({})
          // 判断是否是华侨城环境，然后跳转到华侨城地址
          getLogoutURL(origin)
          resolve()
        } catch (e) {
          // 判断是否是华侨城环境，然后跳转到华侨城地址
          getLogoutURL(origin)
          reject(e)
        }
      })
    },
    // 用户名登录
    LoginByUsername ({commit, rootState}, params) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await services.login({data: params})
          const {appList} = await services.getApplication({data: {type: null}})
          commit('SET_APPS', appList || [])
          setAccount(res)
          setOrigin(window.location.origin)
          if (rootState.app.loginSetting.url) { //  默认进去的应用
            const filterApps = appList.filter(item => item.applicationId === rootState.app.loginSetting.applicationId)
            if (filterApps.length > 0) { //  判断是否有改应用权限
              window.location.href = rootState.app.loginSetting.url
            } else {
              resolve()
            }
          } else if (appList.length === 1 && appList[0].defaultUrl) {
            const defaultUrl = appList[0].defaultUrl
            if (/^(http|https):\/\//.test(defaultUrl)) {
              window.location.href = defaultUrl
            } else {
              resolve()
            }
          } else {
            resolve()
          }
        } catch (e) {
          if (e.respHeader && (e.respHeader.resultCode === 51050 || e.respHeader.resultCode === 41050)) { //  登录验证码错误 错误数肯定至少2
            commit('SET_LOGIN_ERROR_COUNT', 2)
          } else if (e.respBody && e.respBody.loginErrorCount) { //  判断是否有登录错误数返回
            commit('SET_LOGIN_ERROR_COUNT', e.respBody.loginErrorCount)
          }
          reject(e)
        }
      })
    },
    // 判断是否需要短信
    judgeNeedSms ({ commit, rootState, rootCommit }) {
      return new Promise(async (resolve, reject) => {
        let loadingInstance = Loading.service({
          lock: true,
          background: 'rgba(255, 255, 255, 0.3)'
        })
        try {
          const { sms } = await services.appidbyno({ method: 'get', suburl: '?appNo=' + 'FRAME' })
          loadingInstance.close()
          sms && commit('SET_SMS_VERIFY', sms)
          resolve()
        } catch (e) {
          loadingInstance.close()
          reject(e)
        }
      })
    },
    // 明文登录
    V2Login ({ commit, rootState }, params) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await services.v2Login({ data: params, headers: { 'Tag': 'new' } })
          // 校验登录密码是否符合规则，如果不符合，中断登录过程
          if (res.passwordException !== 'PX0000') { // passwordException：密码是否异常：PX0000:正常，PX0001:格式有误，PX0002:密码使用超过有效期
            return resolve(res)
          }
          // 防止退出后再次登录时需要输入图形验证码
          commit('SET_LOGIN_ERROR_COUNT', 0)
          const {appList} = await services.getApplication({data: {type: null}})
          commit('SET_APPS', appList || [])
          setAccount(res)
          setOrigin(window.location.origin)
          if (rootState.app.loginSetting.url) { //  默认进去的应用
            const filterApps = appList.filter(item => item.applicationId === rootState.app.loginSetting.applicationId)
            if (filterApps.length > 0) { //  判断是否有改应用权限
              window.location.href = rootState.app.loginSetting.url
            } else {
              resolve()
            }
          } else if (appList.length === 1 && appList[0].defaultUrl) {
            const defaultUrl = appList[0].defaultUrl
            if (/^(http|https):\/\//.test(defaultUrl)) {
              window.location.href = defaultUrl
            } else {
              resolve()
            }
          } else {
            resolve()
          }
        } catch (e) {
          //  是否需要图形验证码
          if (e && e.code === 100004) {
            commit('SET_LOGIN_ERROR_COUNT', 2)
          } else {
            commit('SET_LOGIN_ERROR_COUNT', 0)
          }
          reject(e)
        }
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js